/** Matches backend {@code com.Unipet.Procurement.Users.Role} enum names. */
export const ROLE_SUPER_ADMIN = 'SuperAdmin';
export const ADMIN_ROLES = ['Admin', ROLE_SUPER_ADMIN] as const;

export function isAdminRole(role: string | null | undefined): boolean {
  return role != null && (ADMIN_ROLES as readonly string[]).includes(role);
}

export function isSuperAdminRole(role: string | null | undefined): boolean {
  if (role == null) {
    return false;
  }
  const normalized = role.trim();
  return (
    normalized === ROLE_SUPER_ADMIN ||
    normalized.toLowerCase() === 'super admin' ||
    normalized.toLowerCase() === 'super_admin'
  );
}
